const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/wallet/ledger/v1frontend/ledger/index', {
      params,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    }).then(res => {
      if (res.data.list) {
        res.data.list = res.data.list.map(item => {
          const r = /^([a-zA-Z])/.exec(item.lgSource)
          if (r) {
            item.type = r[1]
          }
          return item
        })
      }
      return res
    })
  },
  creditdgSearch ({ state, commit, rootState }, params) {
    return rootState.axios.get('/wallet/ledger/v1frontend/creditdg/search', {
      params,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    }).then(res => {
      if (res.data.list) {
        res.data.list = res.data.list.map(item => {
          const r = /^([a-zA-Z])/.exec(item.lgSource)
          if (r) {
            item.type = r[1]
          }
          return item
        })
      }
      return res
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
